import { render, staticRenderFns } from "./TablePromocionesConfig.vue?vue&type=template&id=f62d8c08&scoped=true"
import script from "./TablePromocionesConfig.vue?vue&type=script&lang=js"
export * from "./TablePromocionesConfig.vue?vue&type=script&lang=js"
import style0 from "./TablePromocionesConfig.vue?vue&type=style&index=0&id=f62d8c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62d8c08",
  null
  
)

export default component.exports